var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.6,
    height: 16.6,
    viewBox: "0 0 16.6 16.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_146750",
    "data-name": "Group 146750",
    transform: "translate(-1.7 -1.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50103",
    "data-name": "Path 50103",
    d: "M10,2a8,8,0,1,0,8,8A8,8,0,0,0,10,2Zm0,1.6A6.4,6.4,0,1,1,3.6,10,6.4,6.4,0,0,1,10,3.6ZM8.586,11.131l3.96-3.96A.8.8,0,1,1,13.677,8.3L9.151,12.829a.8.8,0,0,1-1.131,0l-1.7-1.7A.8.8,0,0,1,7.454,10Z",
    fill: "#80838e",
    stroke: "#f3f3f3",
    strokeWidth: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilled);
export default __webpack_public_path__ + "static/media/filled.3497bfc1981399694c74d55e063cfd1f.svg";
export { ForwardRef as ReactComponent };